import { useMutation, useQueryClient } from "@tanstack/react-query";

import { removeUserFromGroup, updateGroupDetails } from "../../services/groups";

type UpdateGroupDetailsBody = {
  name?: string;
  description?: string;
  imageLink?: string;
  userIds: number[];
};

type SaveGroupParams = {
  entityId: number;
  groupId: string;
  body: UpdateGroupDetailsBody;
};

type UpdateGroupParams = {
  entityId: number;
  groupId: string;
  body: UpdateGroupDetailsBody;
};

export const useUpdateGroup = (onSuccess?: () => void, onError?: (error: unknown) => void) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ entityId, groupId, body }: UpdateGroupParams) => updateGroupDetails(entityId, groupId, body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["GroupDetails"] });
      queryClient.invalidateQueries({ queryKey: ["EntityProfile", "GroupsListing"] });
      if (onSuccess) onSuccess();
    },
    onError: (error) => {
      if (onError) onError(error);
    },
  });
};

export const useCreateGroup = (onSuccess?: () => void, onError?: () => void) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ entityId, groupId, body }: SaveGroupParams) => {
      return await updateGroupDetails(entityId, groupId, body);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["GroupDetails"] });
      queryClient.invalidateQueries({ queryKey: ["EntityProfile", "GroupsListing"] });
      if (onSuccess) onSuccess();
    },
    onError: () => {
      if (onError) onError();
    },
  });
};

type removeUserFromGroupParams = {
  userId?: number;
  entityId?: number | null;
  groupId?: string;
};

export const useRemoveUserFromGroup = (onSuccess?: () => void, onError?: () => void) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ entityId, groupId, userId }: removeUserFromGroupParams) => {
      return await removeUserFromGroup(entityId, groupId, userId);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["GroupDetails"] });
      queryClient.invalidateQueries({ queryKey: ["EntityProfile", "GroupsListing"] });
      if (onSuccess) onSuccess();
    },
    onError: () => {
      if (onError) onError();
    },
  });
};
